import logo from 'src/assets/images/logo.gif'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import '../../../scss/App.css'
import ReCAPTCHA from 'react-google-recaptcha'

//import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import {
  CImage,
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'

//import axios from "../api/axios";
import axios from 'axios'

//const endpoint = 'https://apivta.isecol.com.co/api/login'
const endpoint = 'https://api.citas-hicm.org/api/login'

const Login = () => {
  const config = {
    headers: {
      'X-XSRF-TOKEN': document.cookie.replace(
        /(?:(?:^|.*;\s*)XSRF-TOKEN\s*=\s*([^;]*).*$)|^.*$/,
        '$1',
      ),
      'Content-Type': 'application/json',
    },
  }

  const [loading, setLoading] = useState(false)
  const [display, setDisplay] = useState('')
  const [recaptchaValue, setRecaptchaValue] = useState('')

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value)
  }

  const navigate = useNavigate()

  const validateSchema = Yup.object().shape({
    email: Yup.string()
      .email('Por favor ingrese un correo valido!')
      .required('Este campo es obligatorio!'),

    // .test('unique email', 'Ya esta en uso, intenta con otro email!', async (email) => {
    //   try {
    //     const res = await axios.get(`${endpoint}${email}`)
    //       .then((response) => {
    //         //console.log(response.data);
    //         return response;
    //       });

    //   } catch (err) {
    //     //console.error(err);
    //     return err;
    //   }
    // }),

    password: Yup.string().required('Este campo es obligatorio!'),
    //.min(8, "Pasword must be 8 or more characters")
    //.matches(/(?=.*[a-z])(?=.*[A-Z])\w+/, "Password ahould contain at least one uppercase and lowercase character")
    //.matches(/\d/, "Password should contain at least one number")
    //.matches(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/, "Password should contain at least one special character"),
    // c_password: Yup.string().when("password", (password, field) => {
    //   if (password) {
    //     return field.required("Las contraseñas no coinciden").oneOf([Yup.ref("password")], "Las contraseñas no coinciden");
    //   }
    // }),
  })

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },

    validationSchema: validateSchema,

    onSubmit: async (values, { resetForm }) => {
      //e.preventDefault()

      setLoading(true)
      //alert(JSON.stringify(values, null, 2));
      await axios
        .post(endpoint, {
          headers: {
            'X-CSRF-TOKEN': recaptchaValue,
            'Content-Type': 'application/json',
          },
          email: values.email,
          password: values.password,
          recaptcha: recaptchaValue,
        })
        .then((response) => {
          console.log(response.data.success)

          localStorage.setItem('token', JSON.stringify(response.data.success.token))
          localStorage.setItem('role', JSON.stringify(response.data.success.role))
          localStorage.setItem('nro_documento', JSON.stringify(response.data.success.nro_documento))
          localStorage.setItem('email', JSON.stringify(values.email))
          navigate('/dashboard')
          setLoading(false)
          resetForm()
        })
        .catch((err) => {
          setLoading(false)
          setDisplay(err.response.data.message)
        })
    },
  })

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <div className="">
            <CImage align="center" rounded src={logo} alt="Hospital Infantil Concejo de Medellin" />
          </div>
          <CCol md={8}>
            <CCardGroup>
              <CCard className="text-white bg-dark py-5" style={{ width: 'auto' }}>
                <CCardBody className="text-center">
                  <div>
                    <h2>Solicitud de citas.</h2>
                    <p>Para solicitar una cita ingresa a traves del siguiente botón.</p>
                    <Link to="/BuscarPaciente">
                      {/* <Link to="/register"> */}
                      <CButton color="success" active tabIndex={-1}>
                        Solicitar una cita!
                      </CButton>
                    </Link>
                  </div>
                </CCardBody>
              </CCard>
              <CCard className="card_animated p-2">
                <CCardBody>
                  <CForm
                    autoComplete={'off'}
                    className="spaceY-lg w100-small w50-lg"
                    onSubmit={formik.handleSubmit}
                  >
                    <h2>Usuarios registrados</h2>
                    <p className="text-medium-emphasis">
                      Ingresa con tu cuenta previamente registrada.
                    </p>

                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Correo electrónico"
                        autoComplete="email"
                        type={'email'}
                        id="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                    </CInputGroup>
                    <div className="helperText">
                      {formik.errors.email ? formik.errors.email : null}
                    </div>

                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Contraseña"
                        autoComplete="current-password"
                        id="password"
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                      />
                    </CInputGroup>
                    <div id="display" className="text-danger">
                      {formik.errors.password ? formik.errors.password : null}
                    </div>
                    <p className="text-danger">{display}</p>
                    <CRow>
                      <CCol xs={6}>
                        {/* <ReCAPTCHA
                          sitekey="6Lfuc3wpAAAAAPRXhgQSpsx1Kt6xYUB1loh_6lmq"
                          onChange={handleRecaptchaChange}
                        /> */}
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol xs={6}>
                        <CButton color="info" className="px-4" disabled={loading} type={'submit'}>
                          {loading ? 'Cargando...' : 'Entrar'}
                        </CButton>
                      </CCol>
                      <CCol xs={6} className="text-right">
                        <CButton color="link" className="px-0">
                          Olvido su contraseña?
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
